import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateLocationTag = () => {
  return useMutation({
    mutationFn: updateLocationTag,
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.viewLocations.invalidateAll());
      queryClient.invalidateQueries(queryKeys.locationTags.invalidateAll());
      queryClient.invalidateQueries(queryKeys.locations.invalidateAll());
    },
  });
};

const updateLocationTag = async (payload: {
  locationTagId: string;
  locationTag: string;
}) => {
  const request = {
    name: payload.locationTag,
  };

  const response = await requestCCApi({
    url: `/locationTags/${payload.locationTagId}`,
    method: 'PUT',
    data: { data: request },
  });

  return response;
};
